import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { memo } from "react";

import {
  FormTransferList,
  IPrivilegesDomain,
  ISelectType,
  MainApiService,
} from "@4uhub/lib4uhub";
import MainApi from "../../../../../../services/mainApi.service";

const TICKET_CHANNEL_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannels/";
const ticketChannelService = new MainApi<ISelectType>(TICKET_CHANNEL_ROUTE);

const translationPath = "chatBot.page.automations.automationRules.";
const TicketChannelAutomationRule: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} mb={5}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h6">
          {t(translationPath + "ticket_channels")}
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          {t(translationPath + "ticket_channels_subtitle")}
        </Typography>
      </Box>
      <Grid item xs={12} sm={12} mt={2}>
        <FormTransferList<ISelectType>
          request={ticketChannelService.list}
          name="ticketChannels"
          noSoftware={true}
          labelAdded={
            t(translationPath + "add_ticket_channels") ?? "Add Boards"
          }
          label={t(translationPath + "ticket_channels") ?? "Boards"}
        />
      </Grid>
    </Grid>
  );
};

export default memo(TicketChannelAutomationRule);
